import React from 'react'

export default ({ background, children, fullHeight}) => (
  <div id="root-element" className={fullHeight ? 'fullHeight' : ''} style={{backgroundColor: background}}>{children}</div>
)
